// 忘记密码页面
import {Image, ImageBackground, ScrollView, Text, View} from 'react-native';
import {createStyles} from '../../utils/createStyles';
import React, {useEffect, useMemo, useState} from 'react';
import {useNavigation} from '@react-navigation/native';
import LinearGradient from 'react-native-linear-gradient';
import {Button, Input} from '@rneui/themed';
import {Controller, useForm} from 'react-hook-form';
import Toast from 'react-native-toast-message';
import {forgetCodeApi, forgetPasswordApi} from '../../API/user';
import useGetDeviceInfo from '../../hooks/useGetDeviceInfo';

interface itemProps {
  icon?: string;
  children?: any;
  itemStyle?: any[];
}

const ItemComponent = ({icon, children, itemStyle}: itemProps) => (
  <View style={[styles.itemComponentBox, itemStyle]}>
    {icon ? (
      <Image
        style={styles.itemComponentImage}
        resizeMode={'contain'}
        source={{uri: icon}}
      />
    ) : null}
    <View>{children}</View>
  </View>
);
export default function ForgotPassword() {
  const navigation = useNavigation();
  const {uniqueId} = useGetDeviceInfo();
  const initialCodeNum = -1;
  const countdownNum = 60;
  const [codeNum, setCodeNum] = useState(initialCodeNum);
  const {control, handleSubmit, setValue, formState, getValues, watch} =
    useForm({
      reValidateMode: 'onSubmit',
    });
  const currentMobile = watch('mobile');
  const formProps = {
    mobile: {
      control,
      name: 'mobile',
      rules: {
        required: {
          value: true,
          message: '请输入手机号',
        },
        pattern: {
          value: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
          message: '手机号格式不正确',
        },
      },
    },

    code: {
      control,
      name: 'code',
      rules: {
        required: {
          value: true,
          message: '请输入验证码',
        },
      },
    },
    password: {
      control,
      name: 'password',
      rules: {
        required: {
          value: true,
          message: '请输入密码',
        },
      },
    },
    confirmCredential: {
      control,
      name: 'confirmCredential',
      rules: {
        required: {
          value: true,
          message: '请再次输入密码',
        },
        validate: {
          sameAsPassword: (value: any) => {
            if (value === getValues('password')) {
              return true;
            } else {
              return '两次输入密码应相同';
            }
          },
        },
      },
    },
  };
  const sendCode = () => {
    console.log(111, formState, getValues('mobile'));
    if (!currentMobile || currentMobile === '') {
      Toast.show({
        type: 'error',
        text1: '请输入手机号',
      });
      return;
    }
    forgetCodeApi({
      mobile: currentMobile,
      deviceSn: uniqueId,
    })
      .then(res => {
        if (res.status === 200) {
          console.log('res', res);
          Toast.show({
            type: 'success',
            text1: '验证码发送成功',
          });
          setCodeNum(countdownNum);
        } else {
          Toast.show({
            type: 'error',
            // @ts-ignore
            text1: res.msg,
          });
        }
      })
      .catch(e => {
        console.log(e);
      });
  };
  const onSubmit = (data: any) => {
    console.log('data', data);
    forgetPasswordApi({
      ...data,
      registerDevice: uniqueId,
    }).then(res => {
      if (res.status === 200) {
        Toast.show({
          type: 'success',
          text1: '修改密码成功',
        });
        setTimeout(() => {
          // @ts-ignore
          navigation.replace('IndexHome');
        }, 1000);
      } else {
        Toast.show({
          type: 'error',
          // @ts-ignore
          text1: res.msg,
        });
      }
    });
  };
  useEffect(() => {
    let timerId: string | number | NodeJS.Timeout | undefined;

    if (codeNum > 0) {
      timerId = setTimeout(() => {
        setCodeNum(codeNum - 1);
      }, 1000);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [codeNum]);
  // 显示错误
  useEffect(() => {
    const {errors} = formState;
    Object.keys(errors).some(k => {
      if (errors[k]?.message) {
        Toast.show({
          type: 'error',
          text1: errors[k]?.message as string,
        });
      }
      return errors[k]?.message;
    });
  }, [formState]);
  return (
    <ImageBackground
      style={styles.flex1}
      source={require('../../assets/images/bg1.png')}>
      <ScrollView style={styles.fpBox}>
        <ItemComponent
          icon={
            'https://media.oss.leziedu.com/webapp/classroom/rp/rp_phone.png'
          }>
          <View style={styles.itemStyleInput}>
            <Controller
              {...formProps.mobile}
              render={({field: {onChange, onBlur, value}}) => (
                <Input
                  onBlur={onBlur}
                  value={value}
                  onChangeText={onChange}
                  style={styles.textInput}
                  containerStyle={styles.input}
                  inputContainerStyle={{borderBottomWidth: 0}}
                  placeholder="请输入手机号"
                />
              )}
            />
          </View>
        </ItemComponent>
        <ItemComponent
          icon={
            'https://media.oss.leziedu.com/webapp/classroom/rp/rp_code.png'
          }>
          <View style={styles.itemStyleInputCode}>
            <Controller
              {...formProps.code}
              render={({field: {onChange, onBlur, value}}) => (
                <Input
                  onBlur={onBlur}
                  value={value}
                  onChangeText={onChange}
                  style={styles.textInput}
                  containerStyle={styles.input}
                  inputContainerStyle={{borderBottomWidth: 0}}
                  placeholder="请输入验证码"
                />
              )}
            />
            <Button
              buttonStyle={[styles.itemStyleInputCodeBtn]}
              titleStyle={styles.itemStyleInputCodeBtnText}
              disabled={codeNum <= countdownNum && codeNum > 0}
              size={'sm'}
              type="clear"
              onPress={sendCode}
              ViewComponent={LinearGradient} // Don't forget this!
              linearGradientProps={{
                style: {height: 100, flex: 1},
                colors: useMemo(() => {
                  if (currentMobile) {
                    if (codeNum >= 0 && codeNum <= countdownNum) {
                      // During countdown
                      return ['#EBEBED', '#EBEBED'];
                    } else {
                      // Not during countdown
                      return ['#9E99FF', '#6455FF'];
                    }
                  } else {
                    // No mobile number entered
                    return ['#EBEBED', '#EBEBED'];
                  }
                }, [codeNum, countdownNum, currentMobile]),
                start: {x: 0, y: 1},
                end: {x: 1, y: 0},
              }}
              title={codeNum > 0 ? '获取验证码(' + codeNum + ')' : '获取验证码'}
            />
          </View>
        </ItemComponent>
        <ItemComponent
          icon={
            'https://media.oss.leziedu.com/webapp/classroom/rp/rp_password.png'
          }>
          <View style={styles.itemStyleInput}>
            <Controller
              {...formProps.password}
              render={({field: {onChange, onBlur, value}}) => (
                <Input
                  onBlur={onBlur}
                  value={value}
                  onChangeText={onChange}
                  style={styles.textInput}
                  secureTextEntry={true}
                  containerStyle={styles.input}
                  inputContainerStyle={{borderBottomWidth: 0}}
                  placeholder="请设置密码，含数字、字母"
                />
              )}
            />
          </View>
        </ItemComponent>
        <ItemComponent
          icon={
            'https://media.oss.leziedu.com/webapp/classroom/rp/rp_rpassword.png'
          }>
          <View style={styles.itemStyleInput}>
            <Controller
              {...formProps.confirmCredential}
              render={({field: {onChange, onBlur, value}}) => (
                <Input
                  onBlur={onBlur}
                  value={value}
                  onChangeText={onChange}
                  style={styles.textInput}
                  secureTextEntry={true}
                  containerStyle={styles.input}
                  inputContainerStyle={{borderBottomWidth: 0}}
                  placeholder="请再次输入密码"
                />
              )}
            />
          </View>
        </ItemComponent>
        <View>
          <Button
            onPress={handleSubmit(onSubmit as any)}
            containerStyle={styles.rpBtnWrap}
            buttonStyle={styles.rpBtn}
            ViewComponent={LinearGradient} // Don't forget this!
            linearGradientProps={{
              style: {height: 100, flex: 1},
              colors: ['#9E99FF', '#6455FF'],
              start: {x: 0, y: 1},
              end: {x: 1, y: 0},
            }}>
            <Text style={styles.rpBtnText}>确认修改</Text>
          </Button>
        </View>
      </ScrollView>
    </ImageBackground>
  );
}
const styles = createStyles({
  flex1: {
    flex: 1,
    alignItems: 'center',
  },
  fpBox: {
    width: '100%',
    flexDirection: 'column',
    paddingLeft: '25.57rem',
    paddingVertical: '10rem',
  },
  itemComponentBox: {
    height: '3.85rem',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: '0.78rem',
    marginBottom: '1.82rem',
  },
  itemComponentImage: {
    width: '4.17rem',
    height: '3.8rem',
    marginRight: '0.8rem',
  },
  itemStyleInput: {
    width: '43.58rem',
    height: '4.17rem',
    borderRadius: '2.08rem',
    backgroundColor: '#fff',
    paddingLeft: '2.1rem',
  },
  textInput: {
    margin: 0,
    padding: 0,
    fontSize: '1.35rem',
  },
  input: {
    height: '100%',
    flex: 1,
    padding: 0,
    margin: 0,
    flexDirection: 'row',
    alignItems: 'center',
  },
  rpBtnWrap: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: '7.26rem',
  },
  rpBtn: {
    width: '23.07rem',
    height: '5.2rem',
    borderRadius: '3.39rem',
  },
  rpBtnText: {
    color: '#fff',
    fontSize: '1.77rem',
  },
  itemStyleInputCode: {
    width: '43.58rem',
    height: '4.17rem',
    borderRadius: '2.08rem',
    backgroundColor: '#fff',
    paddingLeft: '2.1rem',
    paddingRight: '.82rem',
    // height: '3.85rem',
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemStyleInputCodeLineInput: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemStyleInputCodeBtn: {
    width: '11.5rem',
    height: '3.65rem',
    borderRadius: '1.82rem',
  },
  itemStyleInputCodeBtnText: {
    fontSize: '1.35rem',
    color: '#fff',
  },
  itemStyleInputDiyCode: {
    paddingRight: 0,
  },
  itemStyleInputNoCodeBtn: {
    backgroundColor: '#EBEBED',
  },
});
